interface FormatTimeDurationOptions {
  showZeroValues?: boolean;
  separator?: string;
}

export function formatTimeDuration(
  totalSeconds: number,
  options: FormatTimeDurationOptions = {}
): string {
  const { showZeroValues = false, separator = ' ' } = options;

  if (totalSeconds < 0) return '0s';

  const units: [string, number][] = [
    ['d', Math.floor(totalSeconds / 86400)],
    ['h', Math.floor((totalSeconds % 86400) / 3600)],
    ['m', Math.floor((totalSeconds % 3600) / 60)],
    ['s', totalSeconds % 60]
  ];

  const parts: string[] = [];

  for (let i = 0; i < units.length; i++) {
    const [label, value] = units[i];

    if (label === 's' && value === 0) continue;

    if (value > 0 || showZeroValues || parts.length > 0) {
      parts.push(`${value}${label}`);
    }
  }

  return parts.length ? parts.join(separator) : '0s';
}
